import React from 'react';
import { offer } from '../data/offer';
export function Footer() {
  const links = [{
    label: 'Note legali',
    href: '#'
  }, {
    label: 'Privacy',
    href: '#'
  }, {
    label: 'Contatti',
    href: `mailto:${offer.supportEmail}`
  }];
  return <footer className="border-t border-espresso-line bg-espresso px-5 py-8 text-center text-[13px] text-sand" data-id="element-85" data-mp="32pp4txyirn3c">
      <nav aria-label="Link legali" data-id="element-86" data-mp="36nd1p6jrvpxv">
        <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-87" data-mp="3ueimm04kl8f1">
          {links.map(l => <li key={l.label} data-id="element-88" data-mp="37o7iyd163ey">
              <a href={l.href} className="transition-colors duration-150 hover:text-wood" data-id="element-89" data-mp="37xuse6oxwgy">
                {l.label}
              </a>
            </li>)}
        </ul>
      </nav>
      <p className="mt-3" data-id="element-90" data-mp="3qbvojhhb2r9e">{offer.supportEmail}</p>
      <p className="mt-3" data-id="element-91" data-mp="29zgkbzgigqll">© 2026 {offer.productName}. Tutti i diritti riservati.</p>
    </footer>;
}